import { create } from 'zustand';

import { chartMetricsOptions } from '../helpers/conts';
import type { chartMetricType, OptionType } from '../helpers/types';

interface StoreState {
  primaryMetric: OptionType;
  secondaryMetric: OptionType;
  setMetric: (option: OptionType, type: chartMetricType) => void;
  getOptions: (metric: chartMetricType) => OptionType[];
}

export const useBrandPerformanceChartStore = create<StoreState>((set, get) => ({
  primaryMetric: chartMetricsOptions[0],
  secondaryMetric: chartMetricsOptions[1],
  setMetric: (option, type) => set({ [type]: option }),
  getOptions: (metric) => {
    const secondMetric = get()[metric === 'primaryMetric' ? 'secondaryMetric' : 'primaryMetric'];
    return chartMetricsOptions.filter((m) => m.value !== secondMetric.value);
  },
}));
